import request from '@/utils/request'

let settledApi = {

  /*企业列表*/
  list(data) {
    return request._post('/shop/plus.xiehui.Index/index', data);
},
noticelist(data){
      return request._post('/shop/plus.xiehui.Index/noticelist', data);
},
listx(data) {
    return request._post('/shop/plus.xiehui.Index/indexx', data);
},
getCoreMembers(data){
     return request._post('/shop/plus.core_members.Index/index', data);
},
deleteCoreMember(data){
     return request._post('/shop/plus.core_members.Index/del', data);
},
updateCoreMember(data){
    return request._post('/shop/plus.core_members.Index/edit', data);
},
addCoreMember(data){
    return request._post('/shop/plus.core_members.Index/add', data);
},
/*添加企业*/
add(data) {
    return request._post('/shop/plus.xiehui.Index/add', data);
},
auditXiehuix(data) {
    return request._post('/shop/plus.xiehui.Index/auditXiehuix', data);
},
/*修改企业*/
edit(data) {
    return request._post('/shop/plus.xiehui.Index/edit', data);
},
/*删除企业*/
del(data) {
    return request._post('/shop/plus.xiehui.Index/del', data);
},
/*企业详情*/
detail(data) {
  return request._post('/shop/plus.xiehui.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.xiehui.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.xiehui.Setting/getSetting', data, errorback);
    },
}
export default settledApi;



// WEBPACK FOOTER //
// ./src/api/settled.js